import { v4 as uuidv4 } from 'uuid';
export default () => {
  return {
    valueType: 'ColorPicker',
    componentType: "FormItem",
    FormItemProps: {
      label: '颜色选择器',
      name: uuidv4(),
      rules: [],
      style: {}
    },
    ControlProps: {
      placeholder: "点击选色器选择颜色",
    },
  }
};
